import {QuotationService, QuotationServiceActionType} from '../../../../services/quotation.service';
import {QuotationListInfoModel} from '../../../../models/quotation-list-info.model';
import {MessageManagerService} from '@shared/service/message-manager/message-manager.service';
import {WorkingTypes} from '../../../../models/enums.model';
import {Subject} from 'rxjs';
import {WorkingsService} from '../../../../services/workings.service';
import {SelectCommoditiesService} from '@shared/service/select-commodities.service';
import {AppConfigEnvironment} from '@shared/models/appconfig-environment.model';
import {WorkingModel} from '../../../../models/working.model';
import {QuotationEntry} from '../working-manager.service';
import {LoaderService} from '@shared/service/loader.service';
import {CommonActions} from './common-actions';
import { DossierModel } from '@app/authority/authority-shared/models/dossier.model';

/**
 * Abstract class that contains the action that the assistance center user can do
 */

export abstract class AssistanceCenterActions extends CommonActions {
	static sendQuotation(quotationService: QuotationService, messageManagerService: MessageManagerService, loaderService: LoaderService ,needRefreshDossierSubject: Subject<void>,
						dossierId: string, workingId: string, allQuotations: QuotationListInfoModel, workingType: WorkingTypes): void {
		loaderService.display(true);
		const quotationID: string = allQuotations.quotations.find(item => item.type === workingType).id;
		quotationService.quotationServiceDoPatch(dossierId, workingId, quotationID, QuotationServiceActionType.SEND, message => {
			messageManagerService.pushInnerMessage(message);
			needRefreshDossierSubject.next();
			}, message => {
				messageManagerService.pushInnerMessage(message);
				loaderService.display(false);
			}
		);
	}

	static startWorking(messageManagerService: MessageManagerService, needRefreshDossierSubject: Subject<void>, loaderService: LoaderService,
						workingsService: WorkingsService, selectCommoditiesService: SelectCommoditiesService, dossier: DossierModel, workingId: string,
						allQuotations: QuotationListInfoModel): void {
		loaderService.display(true);
		workingsService.startWorking(dossier, workingId, allQuotations.quotations[0].id, selectCommoditiesService.getAll(),
			message => {
				needRefreshDossierSubject.next();
				messageManagerService.pushInnerMessage(message);
			},
			message => {
				loaderService.display(false);
				messageManagerService.pushInnerMessage(message);
			}
		);
	}

	static stopWorking( messageManagerService: MessageManagerService, needRefreshDossierSubject: Subject<void>, loaderService: LoaderService,
						workingsService: WorkingsService, selectCommoditiesService: SelectCommoditiesService, dossier: DossierModel, workingId: string,
						allQuotations: QuotationListInfoModel): void {
		loaderService.display(true);
		workingsService.stopWorking(dossier, workingId, allQuotations.quotations[0].id,
			selectCommoditiesService.getAll(),
			message => {
				needRefreshDossierSubject.next();
				messageManagerService.pushInnerMessage(message);
			}, message => {
				loaderService.display(false);
				messageManagerService.pushInnerMessage(message);
			}
		);
	}

	static integrateQuotation(quotationService: QuotationService, messageManagerService: MessageManagerService, onEditedQuotationSubject: Subject<any>, loaderService: LoaderService,
								environment: AppConfigEnvironment, dossier: DossierModel, working: WorkingModel, allQuotations: QuotationListInfoModel): void {
		const body: any = {callback_fe_url: environment.QUOTATION_WAITING_PAGE};
		const quotationID: string = allQuotations.quotations.find(item => item.type === working.type).id;
		loaderService.display(true);
		quotationService.integrateIframe(body, dossier, quotationID, working.type, working.id,
		response => {
			loaderService.display(false);
			onEditedQuotationSubject.next(response);
			}, message => {
				loaderService.display(false);
				messageManagerService.pushInnerMessage(message);
			}
		);
	}

	static arrived(messageManagerService: MessageManagerService, workingsService: WorkingsService, tableSelectedEntry: QuotationEntry[], 
		loaderService: LoaderService, needRefreshQuotationsSubject: Subject<void>, dossier: DossierModel, workingId: string, 
		allQuotations: QuotationListInfoModel): void {
			
		loaderService.display(true);
		let id: string = '';
		const selectedEntryIds: QuotationEntry[] = tableSelectedEntry.filter(entry => !!entry.shippingDate);
		if(selectedEntryIds && selectedEntryIds.length > 0){
			workingsService.arrived(dossier,
				workingId,
				allQuotations.quotations[0].id,
				selectedEntryIds.map(e => e.id),
				message => {
					loaderService.display(false);
					needRefreshQuotationsSubject.next();
					messageManagerService.pushInnerMessage(message);
				},
				message => {
					loaderService.display(false);
					messageManagerService.pushInnerMessage(message)
				}
			);
		}
	}


	static billWithoutLastIntegration(quotationService: QuotationService, loaderService: LoaderService, needRefreshDossierSubject: Subject<void>, messageManagerService: MessageManagerService,
										dossierId: string, workingId: string, allQuotations: QuotationListInfoModel): void {
		this.doQuotationPatch(
			quotationService, loaderService, dossierId, workingId, allQuotations, needRefreshDossierSubject, messageManagerService, QuotationServiceActionType.BILL_WITHOUT_LAST_INTEGRATION
		);
	}
}
